module.exports = __webpack_public_path__ + "static/Calibre-SemiboldItalic-6473be72d5216d0ec21d273af09b9fa3.woff";